import type { FaireProductEntity } from "../../entity_types/product";

export const p_tnqznygzkp: FaireProductEntity = {
  token: "p_tnqznygzkp",
  type: "product",
  name: "Golden Santal | 9 oz Luxury Candle | Holiday Gift",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/be01eb033d92305245cd54146c279c1c3b2c19a7dd0f006b32f779ee8390470e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b51d8ec968f72c5f34efe56136f73d3ef0e118ede70d1aa82aaf7509f7c28ee.png",
    "https://cdn.faire.com/fastly/c5bd0583662f14d08b1bb69d2ea9b39ad77960aca7ad8ba9a8b26984334a5b4e.png",
    "https://cdn.faire.com/fastly/c64d46ed5ac523338e7f2b5922b97e4f3de70ebc7e55a9c6a787e6bdaef0b97a.png",
    "https://cdn.faire.com/fastly/c162cfa05fcc6d22d8c5f7b42f3a19d93347d4afd05656cb02451c3a2748199c.png",
    "https://cdn.faire.com/fastly/b54d1ea91befb429216b1474c785262c74b3c201c19628da3b6d0396792d4de9.png",
    "https://cdn.faire.com/fastly/1882a8521b9c0f7ee4b98c46b8593764b9ffae89b9fd944937f1b233dc53f00c.png",
  ],
  priceDollars: 17.5,
  description:
    "Let the warm, inviting scent of Golden Santal fill your space with a touch of luxury. This candle blends the earthy richness of sandalwood and vetiver with subtle hints of amber and violet leaves, creating a serene and soothing atmosphere.\n\nTop: Amber\nHeart: Orris, Cedar\nBase: Violet Leaves, Vetiver, Sandalwood\n\n𝐒𝐢𝐳𝐞 𝐨𝐩𝐭𝐢𝐨𝐧𝐬:\n9 oz. wood wicked gold tin with a lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\n𝐖𝐡𝐲 𝐊𝐚𝐧𝐝𝐥𝐞𝐫𝐲?\n• Natural Coconut Wax\n• Crackling Wooden Wick, Made from FSC Certified Wood.\n• Lead free & Self-trimming Cotton Wick\n• Non Toxic Ingredients\n• Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n• Cruelty Free\n• Handcrafted in Small Batch\n• Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:08.423Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
